import React, { Component } from "react";
// import banner from './../asset/images/banner.jpg';
// import logoRest from './../asset/images/logoRest.png';
import deletee from "./../asset/images/delete.svg";
import logo from "./../asset/images/sepandlogo.png";
import card from "./../asset/images/card.png";
import Back from "./../asset/images/back.svg";
import Tick from "./../asset/images/tick.svg";
import Cancel from "./../asset/images/cancel.svg";
import Phone from "./../asset/images/phoneblack.svg";
import Address from "./../asset/images/addressblack.svg";
import Email from "./../asset/images/email.png";
import Table from "./../asset/images/table.png";
import plus from "./../asset/images/plus.svg";
import minus from "./../asset/images/minus.svg";
import noimage from "./../asset/images/noimage.png";
import language from "./../asset/images/language.svg";
import profile from "./../asset/images/profile.svg";
import { Search } from "react-bootstrap-icons";
import Category from "./../components/Category";
import Group from "./../components/Group";
import Item from "./../components/Item";
import Login from "./../components/Login";
import Profile from "./../components/Profile";
import Language from "./../components/Language";
import { ImpulseSpinner } from "react-spinners-kit";
import BootstrapSwitchButton from "bootstrap-switch-button-react";
import ScrollContainer from "react-indiana-drag-scroll";
import gsap from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";
import CustomButton from "../components/CustomButton";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import { NumericFormat } from "react-number-format";
import { Form, Spinner } from "react-bootstrap";
import { word } from "../words.js";
import refreshIcon from "@iconify/icons-el/refresh";

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

export default class Menu extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeIndex: 0,
      serverResponse: false,
      RestaurantName: "",
      RestaurantDes: "",
      RestaurantPhone: "",
      RestaurantAddress: "",
      RestaurantEmail: "",
      RestaurantLogo: null,
      RestaurantHeader: null,
      Menu: [],
      // MenuReverse: [],
      searchResult: [],
      searchValue: "",
      scrollIsBusy: false,
      priceUnit: "$",
      businessId: "",
      Orders: [],
      showOrderNotifi: false,
      itemCount: 0,
      showShoppingCard: false,
      ShoppingCard: [],
      totalPrice: 0,
      sum: 0,
      sumItem: 0,
      taxPrice: 0,
      servicePrice: 0,
      packingPrice: 0,
      discountPrice: 0,
      submitLoading: false,
      menuType: "",
      TableName: "",
      TableActive: false,
      fadeOverGradiantPercentLeft: "0",
      fadeOverGradiantPercentRight: "0",
      mobileValue: "",
      mobileError: "",
      mobileDisabled: false,
      userLangList: [],
      currentLang: { title: "" },
      defaultLangId: 0,
      currentLangIndex: 0,
      width: 0,
      ModalShow: false,
      modalContent: "",
      showProfile: false,
      businessInfo: null,
      tableNameIsEnglish: false,
      invoiceCalculating: false,
      showHistory: false,
      useDiscount: true,
      checkOrders: false,
      desValue: "",
      pageStatus: "normal",
      paymentToken: "",
    };

    this.categoryClick = this.categoryClick.bind(this);
    this.scrollComplete = this.scrollComplete.bind(this);
    this.calculateScroll = this.calculateScroll.bind(this);
    this.updateTotalPrice = this.updateTotalPrice.bind(this);
    this.calculateOrderCount = this.calculateOrderCount.bind(this);
    this.setCookie = this.setCookie.bind(this);
    this.getCookie = this.getCookie.bind(this);
    this.mobileHandleChange = this.mobileHandleChange.bind(this);
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    this.getUserLanguageList = this.getUserLanguageList.bind(this);
    this.getBusinessInfo = this.getBusinessInfo.bind(this);
    this.setBusinessInfo = this.setBusinessInfo.bind(this);
    this.checkToken = this.checkToken.bind(this);
    this.invoiceCalculator = this.invoiceCalculator.bind(this);
    this.container = React.createRef();
    this.mobileInput = React.createRef();
    this.indianaScroll = React.createRef();
    this.paymentForm = React.createRef();
  }

  categoryClick(index, catName) {
    let elmnt = document.getElementById("g_" + catName);
    if (elmnt !== null && elmnt !== undefined) {
      let margin = 0;
      var n = gsap.utils.toArray(".row");
      if (n === undefined || n === null || n.length === 0) return;
      var s = n[0].offsetTop + n[0].offsetHeight;
      if (window.innerWidth < 768) {
        if (window.pageYOffset >= s) {
          margin = 107;
        } else {
          margin = 180;
        }
      } else {
        if (window.pageYOffset >= s) {
          margin = 65;
        } else {
          margin = 115;
        }
      }

      this.setState({ scrollIsBusy: true }, () => {
        gsap.to(window, {
          duration: 0.5,
          scrollTo: { y: elmnt, offsetY: margin, autoKill: false },
          onComplete: this.scrollComplete,
        });

        this.setState({ activeIndex: index }, () => {
          let container = gsap.utils.toArray(".indiana-scroll-container");
          let menus = gsap.utils.toArray(".menu-link-active");

          let destination =
            menus[0].offsetLeft +
            menus[0].clientWidth / 2 -
            container[0].clientWidth / 2;

          if (this.state.currentLang.direction === "rtl") {
            destination =
              -1 *
              (container[0].clientWidth / 2 -
                menus[0].clientWidth / 2 -
                menus[0].offsetLeft);
          }
          // console.log("====================================");
          // console.log(menus[0].offsetLeft);
          // console.log(menus[0].clientWidth);
          // console.log(container[0].clientWidth);
          // console.log("====================================");

          this.indianaScroll.current.scrollTo({
            left: destination,
          });
          // gsap.to(".indiana-scroll-container", {
          //   duration: 0.3,
          //   scrollTo: {
          //     x: destination,
          //     autoKill: false,
          //   },
          // });
        });
      });
    }
  }

  scrollComplete() {
    this.setState({ scrollIsBusy: false });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    this.checkToken();
  }

  checkToken() {
    var gomenu_user_mobile = this.getCookie("gomenu_user_mobile");
    var gomenu_user_token = this.getCookie("gomenu_user_token");

    if (gomenu_user_mobile && gomenu_user_token) {
      let data = {
        mobile: gomenu_user_mobile,
        token: gomenu_user_token,
      };

      fetch("https://api.sepandplus.ontco.com/publicapi/checkToken", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      })
        .then((res) => res.json())
        .then((resultt) => {
          if (resultt.status === 200) {
            this.setState({ showProfile: true });
            this.setCookie("gomenu_user_mobile", gomenu_user_mobile, 30);
            this.setCookie("gomenu_user_token", gomenu_user_token, 30);
            this.getUserLanguageList();
          } else {
            document.cookie =
              "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            document.cookie =
              "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
            this.setState({ showProfile: false });
            this.getUserLanguageList();
          }
        })
        .catch((err) => {
          document.cookie =
            "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          document.cookie =
            "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          this.setState({ showProfile: false });
          this.getUserLanguageList();
        });
    } else {
      document.cookie =
        "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      document.cookie =
        "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
      this.setState({ showProfile: false });
      this.getUserLanguageList();
    }
  }

  getUserLanguageList() {
    let data = {
      businessCode: this.props.match.params.code,
      token: "c305bf74-4cd9-41e9-b304-a5b94wsaq331c",
    };

    fetch(
      "https://api.sepandplus.ontco.com/publicapi/getBusinessLanguagesWithCode",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          let i = 0;
          result.result.forEach((element) => {
            if (element.defaultLanguage) {
              console.log(element);
              this.setState(
                {
                  currentLang: element,
                  defaultLangId: element.languageId,
                  currentLangIndex: i,
                },
                () => {
                  this.setState({ userLangList: result.result }, () => {
                    this.getBusinessInfo();
                    return;
                  });
                }
              );
            }
            i++;
          });
        } else if (result.status === 401) {
          this.props.history.push("/NotFound");
        }
      })
      .catch((err) => {});
  }

  setBusinessInfo() {
    let resname = "";
    let resdes = "";
    let resaddress = "";
    if (this.state.businessInfo !== null) {
      this.state.businessInfo.infoObj.forEach((element) => {
        if (this.state.currentLang.languageId === element.languageId) {
          resname = element.name;
          resdes = element.descr;
          resaddress = element.address;
        }
      });

      let newTempMenu = JSON.parse(JSON.stringify(this.state.Menu));

      this.setState({
        RestaurantName: resname,
        RestaurantDes: resdes,
        RestaurantAddress: resaddress,
        priceUnit:
          this.state.currentLang.direction === "rtl"
            ? this.state.businessInfo.rtlPriceTitle
            : this.state.businessInfo.ltrPriceTitle,
        // MenuReverse:
        //   this.state.currentLang.direction === "rtl"
        //     ? newTempMenu.reverse()
        //     : this.state.Menu,
        // MenuReverse:
        //   this.state.currentLang.direction === "rtl"
        //     ? newTempMenu.reverse()
        //     : this.state.Menu,
      });
    }
  }

  getBusinessInfo() {
    let data = {
      businessCode: this.props.match.params.code,
      type: "getMenuWithBusinessCode",
      token: "c305bf74-4cd9-41e9-b304-a5b94wsaq331c",
    };

    fetch("https://api.sepandplus.ontco.com/publicapi/getMenu", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        if (result.status !== 200 || result.businessInfo.length === 0) {
          this.props.history.push("/NotFound");
          return;
        }
        let tables = [];
        let tablename = "";
        let tableActive = false;
        result.stationOrderInfo.forEach((element) => {
          if (element.isEnable) {
            tables.push(element);
          }
          if (element.id === Number(this.props.match.params.id)) {
            tablename = element.name;
            if (element.isEnable) {
              tableActive = true;
            } else tableActive = false;
          }
        });

        let tempMenu = [];
        result.result.forEach((element) => {
          if (element.isEnable) {
            tempMenu.push(element);
          }
        });

        var english = /^[A-Za-z0-9]*$/;
        if (english.test(tablename.substring(0, 1))) {
          this.setState({ tableNameIsEnglish: true });
        }

        let newTempMenu = JSON.parse(JSON.stringify(tempMenu));
        this.setState(
          {
            Menu: tempMenu,
            // MenuReverse:
            //   this.state.currentLang.direction === "rtl"
            //     ? newTempMenu.reverse()
            //     : tempMenu,
            // MenuReverse: tempMenu,
            TableActive: tableActive,
            TableName: tablename,
            tables: tables,
            businessInfo: result.businessInfo[0],
            RestaurantPhone: result.businessInfo[0].phoneNumber,
            RestaurantEmail: result.businessInfo[0].email,
            businessId: result.businessInfo[0].id,
            RestaurantLogo:
              "https://api.sepandplus.ontco.com/api/public/" +
              result.businessInfo[0].logo,
            RestaurantHeader:
              "https://api.sepandplus.ontco.com/api/public/" +
              result.businessInfo[0].headerPic,
          },
          () => {
            this.setBusinessInfo();

            this.setState({ serverResponse: true }, () => {
              if (
                this.props.location.state &&
                this.props.location.state.showHistory
              ) {
                this.props.history.replace(this.props.location.pathname, null);
                this.setState({ showHistory: true }, () => {
                  this.setState({
                    modalContent: "profile",
                    ModalShow: true,
                  });
                });
              }

              // if (this.state.currentLang.direction === "rtl") {
              //   let nav = document.querySelector(".indiana-scroll-container");
              //   gsap.to(".indiana-scroll-container", {
              //     duration: 0.3,
              //     scrollTo: {
              //       x: nav.offsetWidth + 1000,
              //       autoKill: false,
              //     },
              //   });
              //   this.setState({
              //     activeIndex: this.state.MenuReverse.length - 1,
              //   });
              // }

              // document.getElementById(
              //   "#indiana-scroll-container"
              // ).scrollLeft = 100;

              // this.indianaScroll.current.scrollLeft = 100;

              var navbar = document.getElementById("categoryContainer");
              window.addEventListener(
                "scroll",
                () => {
                  try {
                    var n = gsap.utils.toArray(".row");
                    if (n === undefined || n === null || n.length === 0) return;
                    var s = n[0].offsetTop + n[0].offsetHeight;
                    if (window.pageYOffset >= s) {
                      navbar.classList.add("fixedTop");
                      if (window.innerWidth < 768) {
                        let searchbox = document.getElementById("searchBox");
                        if (
                          searchbox !== null &&
                          searchbox !== undefined &&
                          this.state.serverResponse
                        )
                          searchbox.style.boxShadow =
                            "0px 5px 15px var(--gray1)";
                      }
                    } else {
                      navbar.classList.remove("fixedTop");
                      let searchbox = document.getElementById("searchBox");
                      if (
                        searchbox !== null &&
                        searchbox !== undefined &&
                        this.state.serverResponse
                      )
                        searchbox.style.boxShadow = "0px 0px 0px transparent";
                    }

                    if (this.state.scrollIsBusy) return;
                    this.calculateScroll(s);
                  } catch (error) {}
                },
                true
              );
            });
          }
        );
      })
      .catch((err) => {});
  }

  calculateScroll(sticky) {
    if (this.state.scrollIsBusy) return;
    const panels = gsap.utils.toArray(".category");
    for (let i = 0; i < panels.length; i++) {
      let margin = 0;

      if (window.innerWidth < 768) {
        if (window.pageYOffset >= sticky) {
          margin = 107;
        } else {
          margin = 180;
        }
      } else {
        if (window.pageYOffset >= sticky) {
          margin = 65;
        } else {
          margin = 115;
        }
      }

      if (i < panels.length - 1) {
        if (
          window.pageYOffset >= panels[i].offsetTop - margin &&
          window.pageYOffset < panels[i + 1].offsetTop - margin
        ) {
          if (i !== this.state.activeIndex) {
            this.setState({ activeIndex: i }, () => {
              let container = gsap.utils.toArray(".indiana-scroll-container");
              let menus = gsap.utils.toArray(".menu-link-active");

              let destination =
                menus[0].offsetLeft +
                menus[0].clientWidth / 2 -
                container[0].clientWidth / 2;

              if (this.state.currentLang.direction === "rtl") {
                destination =
                  -1 *
                  (container[0].clientWidth / 2 -
                    menus[0].clientWidth / 2 -
                    menus[0].offsetLeft);
              }
              this.indianaScroll.current.scrollTo({
                left: destination,
              });
              // let container = gsap.utils.toArray(".indiana-scroll-container");
              // let menus = gsap.utils.toArray(".menu-link-active");
              // gsap.to(".indiana-scroll-container", {
              //   duration: 0.3,
              //   scrollTo: {
              //     x:
              //       menus[0].offsetLeft +
              //       menus[0].clientWidth / 2 -
              //       container[0].clientWidth / 2,
              //     autoKill: false,
              //   },
              // });
            });
          }
        }
      } else if (window.pageYOffset >= panels[i].offsetTop - margin) {
        if (i !== this.state.activeIndex) {
          this.setState({ activeIndex: i }, () => {
            let container = gsap.utils.toArray(".indiana-scroll-container");
            let menus = gsap.utils.toArray(".menu-link-active");

            let destination =
              menus[0].offsetLeft +
              menus[0].clientWidth / 2 -
              container[0].clientWidth / 2;

            if (this.state.currentLang.direction === "rtl") {
              destination =
                -1 *
                (container[0].clientWidth / 2 -
                  menus[0].clientWidth / 2 -
                  menus[0].offsetLeft);
            }
            this.indianaScroll.current.scrollTo({
              left: destination,
            });
            // let container = gsap.utils.toArray(".indiana-scroll-container");
            // let menus = gsap.utils.toArray(".menu-link-active");
            // gsap.to(".indiana-scroll-container", {
            //   duration: 0.3,
            //   scrollTo: {
            //     x:
            //       menus[0].offsetLeft +
            //       menus[0].clientWidth / 2 -
            //       container[0].clientWidth / 2,
            //     autoKill: false,
            //   },
            // });
          });
        }
      }
    }
  }

  searchChange(e) {
    this.setState({ searchValue: e.target.value });
    let result = [];
    if (e.target.value.length > 1) {
      this.state.Menu.forEach((category) => {
        if (category.isEnable) {
          category.items.forEach((item) => {
            if (item.isEnable) {
              item.nameObj.forEach((element) => {
                if (element.languageId === this.state.currentLang.languageId) {
                  if (
                    element.name
                      .replace(/ي/gi, "ی")
                      .toLowerCase()
                      .indexOf(
                        e.target.value.replace(/ي/gi, "ی").toLowerCase()
                      ) > -1
                  ) {
                    result.push(item);
                  }
                }
              });
            }
          });
        }
      });

      if (result.length > 0) {
        this.setState({ searchResult: result });
      } else {
        this.setState({ searchResult: [] });
      }
    } else {
      this.setState({ searchResult: [] });
    }
  }

  ChangeOrder(data, inLastPage) {
    let orders = JSON.parse(JSON.stringify(this.state.Orders));

    let found = false;
    for (let i = 0; i < orders.length; i++) {
      if (orders[i].id === data.id) {
        found = true;
        if (data.quantity > 0) {
          orders[i].quantity = data.quantity;
        } else {
          orders.splice(i, 1);
          i--;
        }
      }
    }

    if (!found) {
      orders.push(data);
    }

    this.setState({ Orders: orders }, () => {
      this.calculateOrderCount();
      if (inLastPage) this.invoiceCalculator();
    });

    if (orders.length > 0) {
      if (!this.state.showOrderNotifi) {
        this.setState({ showOrderNotifi: true }, () => {
          gsap.from(".ordersNotifi", { bottom: -100, duration: 0.4 });
        });
      }
    } else {
      if (this.state.showOrderNotifi) {
        gsap.to(".ordersNotifi", {
          bottom: -100,
          duration: 0.2,
          onComplete: () => {
            this.setState({ showOrderNotifi: false, itemCount: 0 });
          },
        });
      }
    }
  }

  calculateOrderCount() {
    let count = 0;
    this.state.Orders.forEach((element) => {
      count += element.quantity;
    });

    this.setState({ itemCount: count });

    if (this.state.Orders.length === 0) {
      gsap.to(".ordersNotifi", {
        bottom: -100,
        duration: 0,
        onComplete: () => {
          this.setState({
            showOrderNotifi: false,
            itemCount: 0,
            showShoppingCard: false,
          });
        },
      });
    }
  }

  setCookie(cname, cvalue, exdays) {
    var d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + d.toUTCString();
    //console.log('====================================');
    //console.log(expires);
    //console.log('====================================');
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getCookie(cname) {
    var name = cname + "=";
    var ca = document.cookie.split(";");
    for (var i = 0; i < ca.length; i++) {
      var c = ca[i];
      while (c.charAt(0) === " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  onShowShoppingCard() {
    var gomenu_user_mobile = this.getCookie("gomenu_user_mobile");
    var gomenu_user_token = this.getCookie("gomenu_user_token");

    if (gomenu_user_mobile === "" || gomenu_user_token === "") {
      this.setState({ ModalShow: true, modalContent: "login" });
    } else {
      // this.updateTotalPrice();

      this.setState({ showShoppingCard: true, desValue: "" }, () => {
        this.setCookie("gomenu_user_mobile", gomenu_user_mobile, 30);
        this.invoiceCalculator();
      });
    }
  }

  updateTotalPrice() {
    let totalprice = 0;
    this.state.Orders.forEach((element) => {
      totalprice += element.price * element.quantity;
    });

    this.setState({ totalPrice: totalprice });
  }

  onBack() {
    if (this.state.checkOrders) {
      this.onAutoReorder();
    }

    this.setState({ showShoppingCard: false });
  }

  invoiceCalculator() {
    let orders = JSON.parse(JSON.stringify(this.state.Orders));
    let items = [];

    orders.forEach((element) => {
      let temp = {
        foodId: element.id,
        quantity: element.quantity,
      };

      items.push(temp);
    });

    let code;
    if (this.props.match.params.id !== undefined)
      code = this.props.match.params.id;
    else code = this.state.currentSelectedTableId;

    let data = {
      mobile: this.getCookie("gomenu_user_mobile"),
      token: this.getCookie("gomenu_user_token"),
      orderStationId: code,
      businessId: this.state.businessId,
      items: items,
      discount: 0,
      customerMobile: this.getCookie("gomenu_user_mobile"),
    };

    this.setState({ invoiceCalculating: true, useDiscount: true });

    fetch("https://api.sepandplus.ontco.com/publicapi/invoiceCalculator", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);

        if (result.status === 200) {
          this.setState({
            totalPrice: result.invoice.sum,
            sum: result.invoice.sum,
            sumItem: result.invoice.sumItem,
            taxPrice: result.invoice.tax,
            servicePrice: result.invoice.service,
            packingPrice: result.invoice.packing,
            discountPrice: result.invoice.discount,
          });
        } else {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }

        this.setState({ invoiceCalculating: false });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  sendOrderForOnlinePayment(orderId, code) {
    let data = {
      mobile: this.getCookie("gomenu_user_mobile"),
      token: this.getCookie("gomenu_user_token"),
      orderStationId: code,
      orderId: orderId,
      businessCode: this.props.match.params.code,
    };
    console.log(data);
    // this.setState({ submitLoading: true });

    fetch(
      "https://api.sepandplus.ontco.com/publicapi/sendOrderForOnlinePayment",
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }
    )
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          this.setState({ paymentToken: result.paymentToken }, () => {
            this.setState({ pageStatus: "bank" }, () => {
              window.setTimeout(() => {
                this.paymentForm.current.click();
              }, 50);
            });
          });
        } else {
          // toast.error(word[this.state.currentLang.tag]["paymentError"], {
          toast.error(result.message, {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
        }
        this.setState({ submitLoading: false });
      })
      .catch((err) => {
        this.setState({ submitLoading: false });
      });
  }

  onSubmitOrder() {
    let orders = JSON.parse(JSON.stringify(this.state.Orders));
    let items = [];

    orders.forEach((element) => {
      let temp = {
        foodId: element.id,
        foodName: element.name,
        price: element.price,
        quantity: element.quantity,
      };

      items.push(temp);
    });

    let code;
    if (this.props.match.params.id !== undefined)
      code = this.props.match.params.id;
    else code = this.state.currentSelectedTableId;

    let data = {
      mobile: this.getCookie("gomenu_user_mobile"),
      token: this.getCookie("gomenu_user_token"),
      orderStationId: code,
      status: 6,
      descr: this.state.desValue,
      customerMobile: this.getCookie("gomenu_user_mobile"),
      businessId: this.state.businessId,
      items: items,
      discount: this.state.useDiscount ? this.state.discountPrice : 0,
      discountCode: null,
      numberOfGuests: null,
      settlementType: 5,
    };

    this.setState({ submitLoading: true });

    fetch("https://api.sepandplus.ontco.com/publicapi/createNewOrder", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(data),
    })
      .then((res) => res.json())
      .then((result) => {
        console.log(result);
        if (result.status === 200) {
          if (result.onlinePayment)
            this.setState(
              {
                submitLoading: false,
              },
              () => {
                this.sendOrderForOnlinePayment(result.orderId, code);
              }
            );
          else {
            toast.success(word[this.state.currentLang.tag]["orderSuccess"], {
              position: toast.POSITION.BOTTOM_RIGHT,
              hideProgressBar: true,
              autoClose: 6000,
              toastClassName: "toast",
            });
            this.setState({
              showOrderNotifi: false,
              itemCount: 0,
              showShoppingCard: false,
              Orders: [],
              submitLoading: false,
            });
          }
        } else if (result.status === 406) {
          let menu = JSON.parse(JSON.stringify(this.state.Menu));
          // console.log("Menu", this.state.Menu);
          result.categoryBan.forEach((categoryBanItem) => {
            for (let index = menu.length - 1; index >= 0; index--) {
              if (menu[index].id === categoryBanItem.id) menu.splice(index, 1);
            }
          });

          result.foodBan.forEach((foodBanItem) => {
            for (let index = menu.length - 1; index >= 0; index--) {
              for (
                let index1 = menu[index].items.length - 1;
                index1 >= 0;
                index1--
              ) {
                if (menu[index].items[index1].id === foodBanItem.id)
                  menu[index].items.splice(index1, 1);
              }
            }
          });

          // console.log("correct Menu", menu);

          // this.getMenu();
          this.setState({ Menu: menu }, () => {
            this.setState({ checkOrders: true });
          });
          toast.error(word[this.state.currentLang.tag]["orderError406"], {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ submitLoading: false });
        } else {
          toast.error(word[this.state.currentLang.tag]["orderError"], {
            position: toast.POSITION.BOTTOM_RIGHT,
            hideProgressBar: true,
            autoClose: 6000,
            toastClassName: "toast",
          });
          this.setState({ submitLoading: false });
        }
      })
      .catch((err) => {
        //console.log(err);
        this.setState({ submitLoading: false });
      });
  }

  onAutoReorder() {
    this.setState({ checkOrders: false });
    let deleted = [];

    this.state.Orders.forEach((orderItem) => {
      let found = false;
      this.state.Menu.forEach((categoryItem) => {
        categoryItem.items.forEach((productItem) => {
          if (orderItem.id === productItem.id) found = true;
        });
      });
      if (!found) deleted.push(orderItem.id);
    });

    let orders = JSON.parse(JSON.stringify(this.state.Orders));
    deleted.forEach((deletedId) => {
      for (let index = orders.length - 1; index >= 0; index--) {
        if (orders[index].id === deletedId) orders.splice(index, 1);
      }
    });

    this.setState({ Orders: orders }, () => {
      this.calculateOrderCount();
      if (orders.length > 0) this.invoiceCalculator();
    });
  }

  // getMenu() {
  //   let data = {
  //     businessCode: this.props.match.params.code,
  //     type: "getMenuWithBusinessCode",
  //     token: "c305bf74-4cd9-41e9-b304-a5b94wsaq331c",
  //   };

  //   fetch("https://api.sepandplus.ontco.com/publicapi/getMenu", {
  //     method: "POST",
  //     headers: { "Content-Type": "application/json" },
  //     body: JSON.stringify(data),
  //   })
  //     .then((res) => res.json())
  //     .then((result) => {
  //       let tempMenu = [];
  //       result.result.forEach((element) => {
  //         if (element.isEnable) {
  //           tempMenu.push(element);
  //         }
  //       });

  //       let newTempMenu = JSON.parse(JSON.stringify(tempMenu));
  //       this.setState({
  //         Menu: tempMenu,
  //       });
  //     })
  //     .catch((err) => {});
  // }

  onShoppingCardDelete() {
    gsap.to(".ordersNotifi", {
      bottom: -100,
      duration: 0.12,
      onComplete: () => {
        this.setState({
          showOrderNotifi: false,
          itemCount: 0,
          showShoppingCard: false,
          Orders: [],
        });
      },
    });
  }

  hideModal() {
    this.setState({ ModalShow: false, modalContent: "" });
  }

  logoClick() {
    this.props.history.push("/");
  }

  openMap() {
    window.open(" http://maps.google.com/?q=" + this.state.RestaurantAddress);
  }

  mobileHandleChange(event) {
    let telephone = event.target.value;
    if (telephone !== "0" && telephone !== "") {
      if (!Number(telephone)) return;
    }
    this.setState({ mobileValue: event.target.value });
  }

  handleKeyPress(target) {
    if (target.charCode === 13) {
      this.onLogin();
    }
  }

  profileClick() {
    this.setState({ modalContent: "profile", ModalShow: true });
  }

  languageClick() {
    this.setState({ modalContent: "language", ModalShow: true });
  }

  onSelectLanguage(lang) {
    this.setState(
      { currentLang: lang, modalContent: "", ModalShow: false },
      () => {
        this.setBusinessInfo();
      }
    );
  }

  onLoginClick(mobile, token) {
    this.setState(
      {
        showShoppingCard: true,
        desValue: "",
        modalContent: "",
        ModalShow: false,
        showProfile: true,
      },
      () => {
        this.setCookie("gomenu_user_mobile", mobile, 30);
        this.setCookie("gomenu_user_token", token, 30);
        this.invoiceCalculator();
      }
    );
  }

  onLogoutClick() {
    document.cookie =
      "gomenu_user_mobile=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "gomenu_user_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    this.setState({ modalContent: "", ModalShow: false, showProfile: false });
  }

  textHandleChange(e) {
    this.setState({ [e.target.name]: e.target.value });
  }

  render() {
    if (this.state.serverResponse) {
      if (!this.state.showShoppingCard) {
        return (
          <div
            className={
              this.state.currentLang.direction === "rtl"
                ? "rtlStyle IRANSansMobileFont"
                : "ltrStyle SFUIDisplayFont"
            }
          >
            <div
              className="headerDiv"
              style={{
                backgroundImage: "url(" + this.state.RestaurantHeader + ")",
              }}
            >
              <img
                src={logo}
                alt="logo"
                className="gomenuLogo"
                onClick={this.logoClick.bind(this)}
              />

              <div
                className="userbuttonContainer"
                style={{
                  left:
                    this.state.currentLang.direction === "rtl"
                      ? "15px"
                      : "unset",
                  right:
                    this.state.currentLang.direction === "rtl"
                      ? "unset"
                      : "15px",
                  bottom: this.state.width >= 768 ? "10px" : "unset",
                  top: this.state.width < 768 ? "10px" : "unset",
                }}
              >
                {this.state.showProfile && (
                  <CustomButton
                    img={profile}
                    imgWidth={30}
                    textAlign={
                      this.state.currentLang.direction === "rtl"
                        ? "right"
                        : "left"
                    }
                    imgHeight={27}
                    title={
                      this.state.width >= 500
                        ? word[this.state.currentLang.tag]["profile"]
                        : null
                    }
                    fontFamily={
                      this.state.currentLang.direction === "rtl"
                        ? "IRANSansMobile"
                        : "SFUIDisplay"
                    }
                    imgMarginLeft={
                      this.state.currentLang.direction === "rtl" &&
                      this.state.width >= 768
                        ? 5
                        : 0
                    }
                    imgMarginRight={
                      this.state.currentLang.direction === "ltr" &&
                      this.state.width >= 768
                        ? 5
                        : 0
                    }
                    flexDirection="row-reverse"
                    onClick={this.profileClick.bind(this)}
                    width="fit-content"
                  />
                )}
                {this.state.userLangList.length > 1 && (
                  <div style={{ marginTop: "10px" }}>
                    <CustomButton
                      loading={false}
                      img={language}
                      textAlign={
                        this.state.currentLang.direction === "rtl"
                          ? "right"
                          : "left"
                      }
                      imgWidth={30}
                      imgHeight={30}
                      fontFamily={
                        this.state.currentLang.direction === "rtl"
                          ? "IRANSansMobile"
                          : "SFUIDisplay"
                      }
                      title={
                        this.state.width >= 500
                          ? word[this.state.currentLang.tag]["language"] +
                            ": " +
                            this.state.currentLang.title
                          : null
                      }
                      imgMarginLeft={
                        this.state.currentLang.direction === "rtl" &&
                        this.state.width >= 768
                          ? 5
                          : 0
                      }
                      flexDirection="row-reverse"
                      width="fit-content"
                      imgMarginRight={
                        this.state.currentLang.direction === "ltr" &&
                        this.state.width >= 768
                          ? 5
                          : 0
                      }
                      onClick={this.languageClick.bind(this)}
                    />
                  </div>
                )}
              </div>
            </div>

            <div id="allContainer" className="container Restinfo">
              <div className="row">
                <div
                  className="col-md-2 col-2"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    width: "150px",
                  }}
                >
                  <div className="logoRest">
                    <img src={this.state.RestaurantLogo} alt="" />
                  </div>
                </div>

                {/* <div className="col-md-10 col-10" style={{marginBottom:'10px',paddingLeft:this.state.width<992 && this.state.width>767 && this.state.currentLang.direction==='ltr'?'55px':'0',paddingRight:this.state.width<992 && this.state.width>767 && this.state.currentLang.direction==='rtl'?'55px':'0'}}> */}
                <div
                  className="col-md-10 col-10"
                  style={{ marginBottom: "10px" }}
                >
                  <div className="Restname">
                    <div
                      className={
                        this.state.currentLang.direction === "rtl"
                          ? "RestNameContainer IRANSansMobileBoldFont"
                          : "RestNameContainer SFUIDisplayBoldFont"
                      }
                    >
                      <h2
                        style={{
                          marginLeft:
                            this.state.currentLang.direction === "rtl"
                              ? "10px"
                              : "0px",
                          marginRight:
                            this.state.currentLang.direction === "ltr"
                              ? "10px"
                              : "0px",
                          // maxWidth: this.state.width >= 768 ? "unset" : "300px",
                        }}
                      >
                        {this.state.RestaurantName}
                      </h2>

                      <div style={{ minWidth: "10px", minHeight: "10px" }} />

                      {this.state.width >= 768 &&
                        this.state.TableName !== "" && (
                          <div className="tableNameStyle">
                            <img
                              src={Table}
                              style={{
                                width: "22px",
                                height: "22px",
                                objectFit: "contain",
                                marginLeft:
                                  this.state.currentLang.direction === "rtl"
                                    ? "10px"
                                    : "0px",
                                marginRight:
                                  this.state.currentLang.direction === "ltr"
                                    ? "10px"
                                    : "0px",
                              }}
                              alt=""
                            />
                            <div
                              className={
                                !this.state.tableNameIsEnglish
                                  ? "IRANSansMobileFont"
                                  : "SFUIDisplayFont"
                              }
                            >
                              {this.state.TableName}
                            </div>
                            &nbsp;
                            <div
                              className={
                                this.state.currentLang.direction === "rtl"
                                  ? "IRANSansMobileLightFont"
                                  : "SFUIDisplayLightFont"
                              }
                            >
                              {!this.state.TableActive &&
                                word[this.state.currentLang.tag]["notActive"]}
                            </div>
                          </div>
                        )}
                    </div>

                    {this.state.width < 768 && this.state.TableName !== "" && (
                      <div className="tableNameStyle">
                        <img
                          src={Table}
                          style={{
                            width: "22px",
                            height: "22px",
                            objectFit: "contain",
                            marginLeft: "10px",
                          }}
                          alt=""
                        />
                        <div
                          className={
                            !this.state.tableNameIsEnglish
                              ? "IRANSansMobileFont"
                              : "SFUIDisplayFont"
                          }
                        >
                          {this.state.TableName}
                        </div>
                        &nbsp;
                        <div
                          className={
                            this.state.currentLang.direction === "rtl"
                              ? "IRANSansMobileLightFont"
                              : "SFUIDisplayLightFont"
                          }
                        >
                          {!this.state.TableActive &&
                            word[this.state.currentLang.tag]["notActive"]}
                        </div>
                      </div>
                    )}

                    <div
                      className="menuResDesContainer"
                      style={{
                        textAlign:
                          this.state.currentLang.direction === "rtl"
                            ? "left"
                            : "right",
                      }}
                    >
                      <div
                        className="menuResDes"
                        style={{
                          marginLeft:
                            this.state.width > 768 &&
                            this.state.currentLang.direction === "rtl"
                              ? "30px"
                              : "0px",
                          marginRight:
                            this.state.width > 768 &&
                            this.state.currentLang.direction === "ltr"
                              ? "30px"
                              : "0px",
                          textAlign:
                            this.state.width > 768
                              ? this.state.currentLang.direction === "rtl"
                                ? "right"
                                : "left"
                              : "center",
                        }}
                      >
                        {this.state.RestaurantDes}
                      </div>
                      {(this.state.RestaurantPhone !== "" ||
                        this.state.RestaurantAddress !== "" ||
                        this.state.RestaurantEmail !== "") && (
                        <div className="menuResDetailContainer">
                          {this.state.RestaurantPhone &&
                            this.state.RestaurantPhone !== "" && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100%",
                                }}
                              >
                                <img
                                  src={Phone}
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    objectFit: "contain",
                                    marginLeft:
                                      this.state.currentLang.direction === "rtl"
                                        ? "10px"
                                        : "0px",
                                    marginRight:
                                      this.state.currentLang.direction === "ltr"
                                        ? "10px"
                                        : "0px",
                                    transform: "scaleX(-1)",
                                  }}
                                  alt=""
                                />
                                <p>{this.state.RestaurantPhone}</p>
                              </div>
                            )}

                          {this.state.RestaurantEmail &&
                            this.state.RestaurantEmail !== "" && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100%",
                                }}
                              >
                                <img
                                  src={Email}
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    objectFit: "contain",
                                    marginLeft:
                                      this.state.currentLang.direction === "rtl"
                                        ? "10px"
                                        : "0px",
                                    marginRight:
                                      this.state.currentLang.direction === "ltr"
                                        ? "10px"
                                        : "0px",
                                  }}
                                  alt=""
                                />
                                <p>{this.state.RestaurantEmail}</p>
                              </div>
                            )}

                          {this.state.RestaurantAddress &&
                            this.state.RestaurantAddress !== "" && (
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: "row",
                                  width: "100%",
                                }}
                              >
                                <img
                                  src={Address}
                                  style={{
                                    width: "15px",
                                    height: "15px",
                                    objectFit: "contain",
                                    marginLeft:
                                      this.state.currentLang.direction === "rtl"
                                        ? "10px"
                                        : "0px",
                                    marginRight:
                                      this.state.currentLang.direction === "ltr"
                                        ? "10px"
                                        : "0px",
                                  }}
                                  alt=""
                                />
                                <p>{this.state.RestaurantAddress}</p>
                              </div>
                            )}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
              <div
                id="categoryContainer"
                className="row bottom-bar"
                style={{ marginRight: "0", marginLeft: "0" }}
              >
                <div
                  className="col-md-8"
                  style={{ padding: "0", position: "relative" }}
                >
                  {/* <div className="fadeOver" style={{width:'50px',zIndex:'1000',background: 'linear-gradient(90deg, rgba(244,240,237,1) 0%, rgba(0,212,255,0) '+this.state.fadeOverGradiantPercentLeft+'%)',height:'100%',position:'absolute',left:'0',top:'0'}} /> */}
                  {/* <div className="fadeOver" style={{width:'50px',zIndex:'1000',background: 'linear-gradient(270deg, rgba(244,240,237,1) 0%, rgba(0,212,255,0) '+this.state.fadeOverGradiantPercentRight+'%)',height:'100%',position:'absolute',right:'0',top:'0'}} /> */}
                  <div
                    style={{
                      width: "100%",
                      height: "3px",
                      backgroundColor: "#dad5cf",
                      position: "absolute",
                      bottom: "0",
                      left: "0",
                    }}
                  />
                  <ScrollContainer
                    activationDistance={20}
                    style={{ height: "100%" }}
                    innerRef={this.indianaScroll}
                    // id="indiana-scroll-container"
                  >
                    <div className="menu">
                      {this.state.Menu.map((item, i) => {
                        if (item.isEnable) {
                          return (
                            <Category
                              key={i}
                              index={i}
                              isActive={this.state.activeIndex === i}
                              catId={item.id}
                              defaultLangId={this.state.defaultLangId}
                              currentLang={this.state.currentLang}
                              nameObj={item.nameObj}
                              categoryClick={this.categoryClick}
                            />
                          );
                        } else {
                          return null;
                        }
                      })}
                    </div>
                  </ScrollContainer>
                </div>

                <div id="searchBox" className="col-md-4 search-content">
                  <div className="form-group has-search">
                    <span className="fa fa-search form-control-feedback">
                      <Search />
                    </span>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={word[this.state.currentLang.tag]["search"]}
                      onChange={this.searchChange.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </div>

            {this.state.searchValue.length < 2 &&
              this.state.Menu.map((item, i) => {
                if (item.isEnable) {
                  return (
                    <Group
                      key={i}
                      currentLang={this.state.currentLang}
                      nameObj={item.nameObj}
                      isTable={
                        this.props.match.params.id !== undefined &&
                        this.state.TableActive
                          ? true
                          : false
                      }
                      currentOrder={this.state.Orders}
                      ChangeOrder={this.ChangeOrder.bind(this)}
                      foods={item.items}
                      unit={this.state.priceUnit}
                      businessId={this.state.businessId}
                      catId={item.id}
                    />
                  );
                } else {
                  return null;
                }
              })}

            {this.state.searchValue.length > 1 && (
              <Group
                currentLang={this.state.currentLang}
                title={word[this.state.currentLang.tag]["searchResult"]}
                isTable={
                  this.props.match.params.id !== undefined &&
                  this.state.TableActive
                    ? true
                    : false
                }
                currentOrder={this.state.Orders}
                ChangeOrder={this.ChangeOrder.bind(this)}
                unit={this.state.priceUnit}
                businessId={this.state.businessId}
                foods={this.state.searchResult}
                notFound={this.state.searchResult.length === 0}
              />
            )}

            <div style={{ height: "600vh", maxHeight: "55vh" }} />

            {this.state.showOrderNotifi && (
              <div className="ordersNotifi">
                <div
                  className="deleteOrders"
                  onClick={this.onShoppingCardDelete.bind(this)}
                >
                  <img
                    src={deletee}
                    alt="delete"
                    style={{
                      width: "60%",
                      height: "60%",
                      objectFit: "contain",
                    }}
                  />
                </div>
                <div style={{ minWidth: "50px" }} />
                {/* <div className="doneOrders" onClick={this.onShowShoppingCard.bind(this)}> */}
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "doneOrders IRANSansMobileBoldFont"
                      : "doneOrders SFUIDisplayBoldFont"
                  }
                  onClick={this.onShowShoppingCard.bind(this)}
                >
                  <img
                    src={card}
                    alt="done"
                    style={{
                      height: "60%",
                      objectFit: "contain",
                      marginLeft: "10px",
                    }}
                  />
                  {word[this.state.currentLang.tag]["checkout"]} (
                  {this.state.itemCount})
                </div>
              </div>
            )}

            <Modal
              size={
                this.state.modalContent === "login" ||
                this.state.modalContent === "language"
                  ? "sm"
                  : "lg"
              }
              show={this.state.ModalShow}
              animation={false}
              onHide={this.hideModal.bind(this)}
              centered
            >
              {this.state.modalContent === "login" && (
                <Login
                  currentLang={this.state.currentLang}
                  onLoginClick={this.onLoginClick.bind(this)}
                  onCancel={this.hideModal.bind(this)}
                />
              )}
              {this.state.modalContent === "profile" && (
                <Profile
                  showHistory={this.state.showHistory}
                  currentLang={this.state.currentLang}
                  onLogoutClick={this.onLogoutClick.bind(this)}
                  onCancel={this.hideModal.bind(this)}
                  onViewInvoiceClick={(hashId) => {
                    let id = "";
                    if (this.props.match.params.id)
                      id = "/" + this.props.match.params.id;
                    this.props.history.push({
                      pathname: "/invoiceInfo/" + hashId,
                      state: {
                        backURL: this.props.match.params.code + id,
                        showHistory: true,
                      },
                    });
                  }}
                />
              )}
              {this.state.modalContent === "language" && (
                <Language
                  currentLang={this.state.currentLang}
                  userLangList={this.state.userLangList}
                  onLanguageClick={this.onSelectLanguage.bind(this)}
                />
              )}
            </Modal>
          </div>
        );
      } else {
        if (this.state.pageStatus === "normal")
          return (
            <div
              className={
                this.state.currentLang.direction === "rtl"
                  ? "Login rtlStyle IRANSansMobileFont"
                  : "Login ltrStyle SFUIDisplayFont"
              }
            >
              <div className="header">
                <div
                  onClick={this.onBack.bind(this)}
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "linkStyle backButton IRANSansMobileBoldFont"
                      : "linkStyle backButton SFUIDisplayBoldFont"
                  }
                >
                  <img
                    src={Back}
                    alt=""
                    className="backButtonIcon"
                    style={{
                      transform:
                        this.state.currentLang.direction === "rtl"
                          ? "rotate(180deg)"
                          : "rotate(0deg)",
                    }}
                  />
                  {word[this.state.currentLang.tag]["back"]}
                </div>
              </div>
              <div className="LoginContent">
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "RestaurantsListTitle IRANSansMobileBoldFont"
                      : "RestaurantsListTitle SFUIDisplayBoldFont"
                  }
                >
                  {word[this.state.currentLang.tag]["shoppingCard"]}
                </div>
                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "RestaurantsListSubTitle IRANSansMobileBoldFont"
                      : "RestaurantsListSubTitle SFUIDisplayBoldFont"
                  }
                >
                  {word[this.state.currentLang.tag]["finalOrderText"]}
                </div>

                {this.state.checkOrders && (
                  <div
                    className="editableActionPanel"
                    style={{ paddingBottom: "0px" }}
                  >
                    <div style={{ direction: "ltr" }}>
                      <CustomButton
                        title={
                          word[this.state.currentLang.tag]["updateShoppingCard"]
                        }
                        fontSize="16px"
                        icoMarginLeft="10px"
                        ico={refreshIcon}
                        backColor="var(--brown1)"
                        onClick={this.onAutoReorder.bind(this)}
                      />
                    </div>
                  </div>
                )}

                <div className="editableOrderListContainer">
                  {this.state.Orders.map((item, i) => {
                    if (item.quantity > 0) {
                      return (
                        <Item
                          key={i}
                          isShoppingItem
                          currentLang={this.state.currentLang}
                          isTable={
                            this.props.match.params.id !== undefined &&
                            this.state.TableActive
                              ? true
                              : false
                          }
                          currentOrder={this.state.Orders}
                          foodItem={item}
                          businessId={this.state.businessId}
                          id={item.id}
                          nameObj={item.nameObj}
                          descrObj={item.descrObj}
                          price={item.price}
                          unit={this.state.priceUnit}
                          img1={item.foodPicS1}
                          img2={item.foodPicS2}
                          img3={item.foodPicS3}
                          ChangeOrder={this.ChangeOrder.bind(this)}
                        />
                      );
                    } else {
                      return null;
                    }
                  })}
                </div>

                <div
                  style={{
                    width: "100%",
                    height: "1px",
                    backgroundColor: "var(--gray3)",
                    maxWidth: "768px",
                    margin: "10px 0px",
                  }}
                />

                <Form.Control
                  // className="inputStyleForm rtlStyle"
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "inputStyleForm IRANSansMobileFont rtlStyle"
                      : "inputStyleForm SFUIDisplayFont ltrStyle"
                  }
                  placeholder={word[this.state.currentLang.tag]["description"]}
                  style={{
                    maxWidth: "768px",
                    minHeight: "60px",
                    direction: "rtl",
                    marginBottom: "15px",
                  }}
                  type="text"
                  as="textarea"
                  name="desValue"
                  onChange={this.textHandleChange.bind(this)}
                  value={this.state.desValue}
                />

                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "editablePriceContainer IRANSansMobileFont"
                      : "editablePriceContainer SFUIDisplayFont"
                  }
                >
                  <div>{word[this.state.currentLang.tag]["total"]}</div>
                  {!this.state.invoiceCalculating && (
                    <div>
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.sumItem}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp;{this.state.priceUnit}
                    </div>
                  )}

                  {this.state.invoiceCalculating && (
                    <div>
                      <ImpulseSpinner
                        size={25}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>

                {this.state.taxPrice > 0 && (
                  <div
                    className={
                      this.state.currentLang.direction === "rtl"
                        ? "editablePriceContainer IRANSansMobileFont"
                        : "editablePriceContainer SFUIDisplayFont"
                    }
                  >
                    <div>{word[this.state.currentLang.tag]["tax"]}</div>
                    {!this.state.invoiceCalculating && (
                      <div>
                        <NumericFormat
                          allowNegative={true}
                          value={this.state.taxPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        &nbsp;{this.state.priceUnit}
                      </div>
                    )}

                    {this.state.invoiceCalculating && (
                      <div>
                        <ImpulseSpinner
                          size={25}
                          frontColor="var(--black1)"
                          backColor="var(--gray1)"
                          loading={true}
                        />
                      </div>
                    )}
                  </div>
                )}

                {this.state.servicePrice > 0 && (
                  <div
                    className={
                      this.state.currentLang.direction === "rtl"
                        ? "editablePriceContainer IRANSansMobileFont"
                        : "editablePriceContainer SFUIDisplayFont"
                    }
                  >
                    <div>{word[this.state.currentLang.tag]["services"]}</div>
                    {!this.state.invoiceCalculating && (
                      <div>
                        <NumericFormat
                          allowNegative={true}
                          value={this.state.servicePrice}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        &nbsp;{this.state.priceUnit}
                      </div>
                    )}

                    {this.state.invoiceCalculating && (
                      <div>
                        <ImpulseSpinner
                          size={25}
                          frontColor="var(--black1)"
                          backColor="var(--gray1)"
                          loading={true}
                        />
                      </div>
                    )}
                  </div>
                )}

                {this.state.packingPrice > 0 && (
                  <div
                    className={
                      this.state.currentLang.direction === "rtl"
                        ? "editablePriceContainer IRANSansMobileFont"
                        : "editablePriceContainer SFUIDisplayFont"
                    }
                  >
                    <div>{word[this.state.currentLang.tag]["packing"]}</div>
                    {!this.state.invoiceCalculating && (
                      <div>
                        <NumericFormat
                          allowNegative={true}
                          value={this.state.packingPrice}
                          displayType={"text"}
                          thousandSeparator={true}
                        />
                        &nbsp;{this.state.priceUnit}
                      </div>
                    )}

                    {this.state.invoiceCalculating && (
                      <div>
                        <ImpulseSpinner
                          size={25}
                          frontColor="var(--black1)"
                          backColor="var(--gray1)"
                          loading={true}
                        />
                      </div>
                    )}
                  </div>
                )}

                {this.state.discountPrice > 0 && (
                  <div
                    className={
                      this.state.currentLang.direction === "rtl"
                        ? "editablePriceContainer IRANSansMobileFont"
                        : "editablePriceContainer SFUIDisplayFont"
                    }
                  >
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      {word[this.state.currentLang.tag]["credit"]}&nbsp;(
                      {!this.state.invoiceCalculating && (
                        <div>
                          <NumericFormat
                            allowNegative={true}
                            value={this.state.discountPrice}
                            displayType={"text"}
                            thousandSeparator={true}
                          />
                          &nbsp;{this.state.priceUnit}
                        </div>
                      )}
                      {this.state.invoiceCalculating && (
                        <div
                          style={{
                            height: "28px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                          }}
                        >
                          <ImpulseSpinner
                            size={25}
                            frontColor="var(--black1)"
                            backColor="var(--gray1)"
                            loading={true}
                          />
                        </div>
                      )}
                      )
                    </div>
                    <div className="checkBoxStyle">
                      <BootstrapSwitchButton
                        checked={this.state.useDiscount}
                        onChange={(checked) => {
                          this.setState({
                            useDiscount: checked,
                            totalPrice: !checked
                              ? this.state.sum + this.state.discountPrice
                              : this.state.sum,
                          });
                        }}
                        onlabel={word[this.state.currentLang.tag]["active"]}
                        offlabel={word[this.state.currentLang.tag]["deactive"]}
                        onstyle="primary"
                        offstyle="disabled"
                        width={75}
                        style={{ fontSize: "12px" }}
                      />
                    </div>
                  </div>
                )}

                <div
                  style={{
                    width: "100%",
                    minHeight: "1px",
                    backgroundColor: "var(--gray3)",
                    margin: "8px 0px",
                    maxWidth: "768px",
                  }}
                />

                <div
                  className={
                    this.state.currentLang.direction === "rtl"
                      ? "editableTotalContainer IRANSansMobileBoldFont"
                      : "editableTotalContainer SFUIDisplayBoldFont"
                  }
                >
                  <div>{word[this.state.currentLang.tag]["totalPrice"]}</div>
                  {!this.state.invoiceCalculating && (
                    <div>
                      <NumericFormat
                        allowNegative={true}
                        value={this.state.totalPrice}
                        displayType={"text"}
                        thousandSeparator={true}
                      />
                      &nbsp;{this.state.priceUnit}
                    </div>
                  )}

                  {this.state.invoiceCalculating && (
                    <div>
                      <ImpulseSpinner
                        size={35}
                        frontColor="var(--black1)"
                        backColor="var(--gray1)"
                        loading={true}
                      />
                    </div>
                  )}
                </div>

                <div className="editableActionPanel">
                  <div style={{ width: "100%", direction: "ltr" }}>
                    <CustomButton
                      title={word[this.state.currentLang.tag]["checkout"]}
                      fontSize="22px"
                      loadingHeight="30px"
                      loadingWidth="30px"
                      imgHeight="30px"
                      imgWidth="30px"
                      minHeight="60px"
                      loading={this.state.submitLoading}
                      disabled={this.state.invoiceCalculating}
                      img={Tick}
                      backColor="var(--green1)"
                      onClick={this.onSubmitOrder.bind(this)}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        else
          return (
            <form
              style={{ display: "none" }}
              // onLoad="document.forms['forms'].submit()"
              action="https://sep.shaparak.ir/OnlinePG/OnlinePG"
              method="post"
            >
              <input
                type="hidden"
                name="Token"
                value={this.state.paymentToken}
              />
              <input type="text" name="GetMethod" value="true" />
              <input
                ref={this.paymentForm}
                type="submit"
                name="submit"
                value="submit"
              />
            </form>
          );
      }
    } else {
      return (
        <div className="loadingStyle">
          <ImpulseSpinner
            size={50}
            frontColor="var(--brown1)"
            backColor="var(--gray1)"
            loading={true}
          />
        </div>
      );
    }
  }
}
